// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PostReviewIntelligentPartnerNodeBody,
    BaseResponseIntelligentPartnerDialogFlowNodeFoundResponse,
} from '../../../types';

/**
 * 保存对话流程节点
 *
 * @export
 * @tags 智能陪练-对话流程(节点, 全局配置, 客户画像)
 * @link [POST] /review/intelligentPartner/node
 */
export function postReviewIntelligentPartnerNode(
    data: PostReviewIntelligentPartnerNodeBody
): Promise<BaseResponseIntelligentPartnerDialogFlowNodeFoundResponse>;
export function postReviewIntelligentPartnerNode(
    data: PostReviewIntelligentPartnerNodeBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerDialogFlowNodeFoundResponse>;
export function postReviewIntelligentPartnerNode(
    data: PostReviewIntelligentPartnerNodeBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerDialogFlowNodeFoundResponse> {
    return request<PostReviewIntelligentPartnerNodeBody, never, never>(
        '/review/intelligentPartner/node',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postReviewIntelligentPartnerNode',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练-对话流程(节点, 全局配置, 客户画像)'],
        path: '/review/intelligentPartner/node',
        method: 'post',
    },
];
